import { useState, forwardRef } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

import { cn } from "../../lib/utils";

const Input = forwardRef(({ className, type, isPassword, containerStyle, ...props }, ref) => {
	const [showPassword, setShowPassword] = useState(false);
	return (
		<div className={cn("relative flex items-center", containerStyle)}>
			<input
				type={showPassword ? "text" : type}
				className={cn(
					"flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
					{ "pr-10": isPassword },
					className
				)}
				ref={ref}
				{...props}
			/>
			{isPassword && (
				<button
					type="button"
					className="absolute top-3 right-4"
					onClick={() => {
						setShowPassword(!showPassword);
					}}
				>
					{showPassword ? <IoMdEyeOff /> : <IoMdEye />}
				</button>
			)}
		</div>
	);
});
Input.displayName = "Input";

export { Input };
